import { Divider } from '@mantine/core';
import { AuthorityArrangementFields } from 'src/non-financial-data/components/AuthorityArrangementFields';
import {
  EstateContextFields,
  WillDetailFields,
} from 'src/non-financial-data/components/EstateDocumentFields';
import { ProfileFormField } from 'src/non-financial-data/components/ProfileFormField';

export function EstatePlanningFields() {
  return (
    <>
      <EstateContextFields />
      <Divider />
      <WillDetailFields />
      <Divider />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="has_power_of_attorney"
        label="Do you have appointed power of attorney?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="power_of_attorney_info"
        label="Power of attorney — more information"
      />
      <AuthorityArrangementFields />
      <Divider />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="has_started_inheritance_planning"
        label="Have you started inheritance planning?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="started_inheritance_planning_info"
        label="Inheritance planning — more information"
      />
      <ProfileFormField entityType="EstatePlanning" fieldName="gift_record" label="Gift record" />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="charitable_contribution_record"
        label="Charitable contributions record"
      />
    </>
  );
}
